module.exports = __webpack_public_path__ + "img/63.f2c32e51.png";